module.exports = __webpack_public_path__ + "img/var_initialization_cycle.6b04cc90.png";